import React, {useMemo} from 'react';
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import DataTable from "react-data-table-component";
import CommissionSlabDetail from "./CommissionSlabDetail";
import customStyles from "../TableStyles";
import ComponentCard from "../ComponentCard";

const CommissionSlabs = (props) => {

    const isDarkMode = useSelector((state) => state.customizer.isDark);

    const columns = useMemo(() => [
        {
            name: 'Code',
            sortId: 'code',
            sortable: true,
            selector: row => row[0],
            width: '250px',
            wrap: true,
            reorder: true,
            filterable: true,
        }
    ], []);

    return (
            <ComponentCard>
                <DataTable
                    noTableHead
                    columns={columns}
                    data={Object.entries(props.data.slabs || [])}
                    striped
                    dense
                    theme={isDarkMode ? 'iDark' : 'iLight'}
                    customStyles={customStyles}
                    expandableRows
                    expandableRowsComponent={CommissionSlabDetail}
                />
            </ComponentCard>
        )
};

CommissionSlabs.propTypes = {
    data: PropTypes.object,
};

export default CommissionSlabs;
